/**
 * @generated SignedSource<<2ad7fc0de4563a4e3ae35f9b9d936189>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type GoalStateValue = "archived" | "at_risk" | "cancelled" | "done" | "off_track" | "on_track" | "paused" | "pending";
export type UpdateType = "SYSTEM" | "USER";
export type GoalUpdateComposerEmbedQuery$variables = {
  isExistingUpdate: boolean;
  key: string;
  updateId: string;
};
export type GoalUpdateComposerEmbedQuery$data = {
  readonly goalByKey?: {
    readonly state: {
      readonly score: number | null;
      readonly value: GoalStateValue | null;
    } | null;
    readonly targetDate: string | null;
    readonly targetDateConfidence: number | null;
    readonly " $fragmentSpreads": FragmentRefs<"GoalUpdateComposer">;
  } | null;
  readonly goalUpdate?: {
    readonly goal: {
      readonly updates: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly ari: string;
          } | null;
        } | null> | null;
      } | null;
    } | null;
    readonly missedUpdate: boolean;
    readonly updateType: UpdateType | null;
    readonly " $fragmentSpreads": FragmentRefs<"EditGoalUpdate">;
  } | null;
};
export type GoalUpdateComposerEmbedQuery = {
  response: GoalUpdateComposerEmbedQuery$data;
  variables: GoalUpdateComposerEmbedQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isExistingUpdate"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "key"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "updateId"
},
v3 = [
  {
    "kind": "Variable",
    "name": "key",
    "variableName": "key"
  }
],
v4 = {
  "kind": "ScalarField",
  "name": "value"
},
v5 = {
  "kind": "ScalarField",
  "name": "score"
},
v6 = {
  "concreteType": "GoalState",
  "kind": "LinkedField",
  "name": "state",
  "plural": false,
  "selections": [
    (v4/*: any*/),
    (v5/*: any*/)
  ]
},
v7 = {
  "kind": "ScalarField",
  "name": "targetDate"
},
v8 = {
  "kind": "ScalarField",
  "name": "targetDateConfidence"
},
v9 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "updateId"
  }
],
v10 = {
  "kind": "ScalarField",
  "name": "missedUpdate"
},
v11 = {
  "kind": "ScalarField",
  "name": "updateType"
},
v12 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 1
  }
],
v13 = {
  "kind": "ScalarField",
  "name": "ari"
},
v14 = {
  "kind": "ScalarField",
  "name": "name"
},
v15 = [
  (v14/*: any*/)
],
v16 = {
  "kind": "ScalarField",
  "name": "id"
},
v17 = {
  "kind": "ScalarField",
  "name": "uuid"
},
v18 = {
  "kind": "ScalarField",
  "name": "key"
},
v19 = {
  "concreteType": "Workspace",
  "kind": "LinkedField",
  "name": "workspace",
  "plural": false,
  "selections": [
    (v17/*: any*/),
    (v16/*: any*/),
    {
      "concreteType": "WorkspaceAIConfig",
      "kind": "LinkedField",
      "name": "aiConfig",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "enabled"
        }
      ]
    }
  ]
},
v20 = [
  {
    "kind": "ScalarField",
    "name": "count"
  }
],
v21 = {
  "kind": "ScalarField",
  "name": "editDate"
},
v22 = {
  "kind": "ScalarField",
  "name": "creationDate"
},
v23 = {
  "kind": "ScalarField",
  "name": "summary"
},
v24 = {
  "concreteType": "UpdateNote",
  "kind": "LinkedField",
  "name": "notes",
  "plural": true,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "title"
    },
    (v23/*: any*/),
    (v16/*: any*/)
  ]
},
v25 = {
  "kind": "ScalarField",
  "name": "type"
},
v26 = {
  "kind": "ScalarField",
  "name": "archived"
},
v27 = {
  "kind": "ScalarField",
  "name": "subType"
},
v28 = {
  "kind": "ScalarField",
  "name": "source"
},
v29 = {
  "concreteType": "MetricValue",
  "kind": "LinkedField",
  "name": "latestValue",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "time"
    },
    (v16/*: any*/)
  ]
},
v30 = [
  (v4/*: any*/),
  (v16/*: any*/)
],
v31 = {
  "concreteType": "Goal",
  "kind": "LinkedField",
  "name": "parentGoal",
  "plural": false,
  "selections": [
    (v17/*: any*/),
    (v16/*: any*/)
  ]
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "name": "GoalUpdateComposerEmbedQuery",
    "selections": [
      {
        "condition": "isExistingUpdate",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "args": (v3/*: any*/),
            "concreteType": "Goal",
            "kind": "LinkedField",
            "name": "goalByKey",
            "plural": false,
            "selections": [
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              {
                "args": [
                  {
                    "kind": "Literal",
                    "name": "goalUpdateDraftsEnabled",
                    "value": false
                  }
                ],
                "kind": "FragmentSpread",
                "name": "GoalUpdateComposer"
              }
            ]
          }
        ]
      },
      {
        "condition": "isExistingUpdate",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": (v9/*: any*/),
            "concreteType": "GoalUpdate",
            "kind": "LinkedField",
            "name": "goalUpdate",
            "plural": false,
            "selections": [
              {
                "kind": "FragmentSpread",
                "name": "EditGoalUpdate"
              },
              (v10/*: any*/),
              (v11/*: any*/),
              {
                "concreteType": "Goal",
                "kind": "LinkedField",
                "name": "goal",
                "plural": false,
                "selections": [
                  {
                    "args": (v12/*: any*/),
                    "concreteType": "GoalUpdateConnection",
                    "kind": "LinkedField",
                    "name": "updates",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "GoalUpdateEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "concreteType": "GoalUpdate",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v13/*: any*/)
                            ]
                          }
                        ]
                      }
                    ],
                    "storageKey": "updates(first:1)"
                  }
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v2/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "GoalUpdateComposerEmbedQuery",
    "selections": [
      {
        "condition": "isExistingUpdate",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "args": (v3/*: any*/),
            "concreteType": "Goal",
            "kind": "LinkedField",
            "name": "goalByKey",
            "plural": false,
            "selections": [
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              {
                "concreteType": "GoalPhaseDetails",
                "kind": "LinkedField",
                "name": "phase",
                "plural": false,
                "selections": (v15/*: any*/)
              },
              {
                "kind": "ScalarField",
                "name": "latestUpdateDate"
              },
              (v16/*: any*/),
              (v17/*: any*/),
              (v18/*: any*/),
              (v19/*: any*/),
              {
                "concreteType": "UserConnection",
                "kind": "LinkedField",
                "name": "watchers",
                "plural": false,
                "selections": (v20/*: any*/)
              },
              {
                "concreteType": "GoalUpdate",
                "kind": "LinkedField",
                "name": "latestUserUpdate",
                "plural": false,
                "selections": [
                  (v16/*: any*/),
                  (v21/*: any*/),
                  (v22/*: any*/),
                  (v23/*: any*/),
                  (v24/*: any*/)
                ]
              },
              {
                "concreteType": "GoalProgress",
                "kind": "LinkedField",
                "name": "progress",
                "plural": false,
                "selections": [
                  (v25/*: any*/),
                  {
                    "kind": "ScalarField",
                    "name": "percentage"
                  }
                ]
              },
              {
                "concreteType": "MetricTargetConnection",
                "kind": "LinkedField",
                "name": "metricTargets",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "MetricTargetEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "MetricTarget",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v16/*: any*/),
                          {
                            "concreteType": "Metric",
                            "kind": "LinkedField",
                            "name": "metric",
                            "plural": false,
                            "selections": [
                              (v26/*: any*/),
                              (v16/*: any*/),
                              (v14/*: any*/),
                              (v25/*: any*/),
                              (v27/*: any*/),
                              (v28/*: any*/),
                              (v29/*: any*/)
                            ]
                          },
                          {
                            "concreteType": "MetricValue",
                            "kind": "LinkedField",
                            "name": "snapshotValue",
                            "plural": false,
                            "selections": (v30/*: any*/)
                          },
                          {
                            "kind": "ScalarField",
                            "name": "startValue"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "targetValue"
                          }
                        ]
                      }
                    ]
                  }
                ]
              },
              (v31/*: any*/),
              {
                "concreteType": "GoalConnection",
                "kind": "LinkedField",
                "name": "subGoals",
                "plural": false,
                "selections": (v20/*: any*/)
              },
              {
                "alias": "latestUpdates",
                "args": (v12/*: any*/),
                "concreteType": "GoalUpdateConnection",
                "kind": "LinkedField",
                "name": "updates",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "GoalUpdateEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "GoalUpdate",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v16/*: any*/),
                          (v22/*: any*/),
                          (v10/*: any*/),
                          (v11/*: any*/)
                        ]
                      }
                    ]
                  }
                ],
                "storageKey": "updates(first:1)"
              },
              (v13/*: any*/)
            ]
          }
        ]
      },
      {
        "condition": "isExistingUpdate",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": (v9/*: any*/),
            "concreteType": "GoalUpdate",
            "kind": "LinkedField",
            "name": "goalUpdate",
            "plural": false,
            "selections": [
              (v16/*: any*/),
              (v17/*: any*/),
              (v23/*: any*/),
              {
                "concreteType": "GoalPhaseDetails",
                "kind": "LinkedField",
                "name": "newPhase",
                "plural": false,
                "selections": (v15/*: any*/)
              },
              {
                "alias": "newGoalState",
                "concreteType": "GoalState",
                "kind": "LinkedField",
                "name": "newState",
                "plural": false,
                "selections": [
                  (v5/*: any*/),
                  (v4/*: any*/)
                ]
              },
              {
                "kind": "ScalarField",
                "name": "newTargetDate"
              },
              {
                "kind": "ScalarField",
                "name": "newTargetDateConfidence"
              },
              {
                "concreteType": "UpdateNote",
                "kind": "LinkedField",
                "name": "notes",
                "plural": true,
                "selections": [
                  (v23/*: any*/),
                  (v17/*: any*/),
                  (v16/*: any*/)
                ]
              },
              {
                "concreteType": "Goal",
                "kind": "LinkedField",
                "name": "goal",
                "plural": false,
                "selections": [
                  (v16/*: any*/),
                  (v18/*: any*/),
                  (v17/*: any*/),
                  (v19/*: any*/),
                  {
                    "concreteType": "GoalUpdate",
                    "kind": "LinkedField",
                    "name": "latestUserUpdate",
                    "plural": false,
                    "selections": [
                      (v21/*: any*/),
                      (v22/*: any*/),
                      (v23/*: any*/),
                      (v24/*: any*/),
                      (v16/*: any*/)
                    ]
                  },
                  {
                    "concreteType": "MetricTargetConnection",
                    "kind": "LinkedField",
                    "name": "metricTargets",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "MetricTargetEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "concreteType": "MetricTarget",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "Metric",
                                "kind": "LinkedField",
                                "name": "metric",
                                "plural": false,
                                "selections": [
                                  (v16/*: any*/),
                                  (v26/*: any*/)
                                ]
                              },
                              (v16/*: any*/)
                            ]
                          }
                        ]
                      }
                    ]
                  },
                  (v31/*: any*/),
                  {
                    "args": (v12/*: any*/),
                    "concreteType": "GoalUpdateConnection",
                    "kind": "LinkedField",
                    "name": "updates",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "GoalUpdateEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "concreteType": "GoalUpdate",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v13/*: any*/),
                              (v16/*: any*/)
                            ]
                          }
                        ]
                      }
                    ],
                    "storageKey": "updates(first:1)"
                  }
                ]
              },
              {
                "concreteType": "GoalMetricUpdateConnection",
                "kind": "LinkedField",
                "name": "metricUpdate",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "GoalMetricUpdateEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "GoalMetricUpdate",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "Metric",
                            "kind": "LinkedField",
                            "name": "metric",
                            "plural": false,
                            "selections": [
                              (v16/*: any*/),
                              (v14/*: any*/),
                              (v25/*: any*/),
                              (v27/*: any*/),
                              (v26/*: any*/),
                              (v28/*: any*/),
                              (v29/*: any*/)
                            ]
                          },
                          {
                            "concreteType": "MetricValue",
                            "kind": "LinkedField",
                            "name": "newValue",
                            "plural": false,
                            "selections": (v30/*: any*/)
                          },
                          {
                            "kind": "ScalarField",
                            "name": "newStartValue"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "newTargetValue"
                          }
                        ]
                      }
                    ]
                  }
                ]
              },
              (v10/*: any*/),
              (v11/*: any*/)
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "68b9fc20ee8fb8375e13065875175b46",
    "id": null,
    "metadata": {},
    "name": "GoalUpdateComposerEmbedQuery",
    "operationKind": "query",
    "text": "query GoalUpdateComposerEmbedQuery(\n  $key: String!\n  $updateId: ID!\n  $isExistingUpdate: Boolean!\n) {\n  goalByKey(key: $key) @skip(if: $isExistingUpdate) {\n    state {\n      value\n      score\n    }\n    targetDate\n    targetDateConfidence\n    ...GoalUpdateComposer_2WXTlx\n    id\n  }\n  goalUpdate(id: $updateId) @include(if: $isExistingUpdate) {\n    ...EditGoalUpdate\n    missedUpdate\n    updateType\n    goal {\n      updates(first: 1) {\n        edges {\n          node {\n            ari\n            id\n          }\n        }\n      }\n      id\n    }\n    id\n  }\n}\n\nfragment AddToMissedUpdateMessage on Goal {\n  id\n  latestUpdates: updates(first: 1) {\n    edges {\n      node {\n        id\n        creationDate\n        missedUpdate\n        updateType\n      }\n    }\n  }\n}\n\nfragment DueDateContext on Goal {\n  phase {\n    name\n  }\n  latestUpdateDate\n}\n\nfragment EditGoalProgressEditor on GoalUpdate {\n  metricUpdate {\n    edges {\n      node {\n        metric {\n          id\n          name\n          type\n          subType\n          archived\n          source\n          latestValue {\n            time\n            id\n          }\n        }\n        newValue {\n          value\n          id\n        }\n        newStartValue\n        newTargetValue\n      }\n    }\n  }\n}\n\nfragment EditGoalUpdate on GoalUpdate {\n  id\n  uuid\n  summary\n  newPhase {\n    name\n  }\n  newGoalState: newState {\n    score\n    value\n  }\n  newTargetDate\n  newTargetDateConfidence\n  notes {\n    summary\n    uuid\n    id\n  }\n  goal {\n    id\n    key\n    uuid\n    workspace {\n      uuid\n      id\n      aiConfig {\n        enabled\n      }\n    }\n    latestUserUpdate {\n      editDate\n      creationDate\n      summary\n      notes {\n        title\n        summary\n        id\n      }\n      id\n    }\n    metricTargets {\n      edges {\n        node {\n          metric {\n            id\n            archived\n          }\n          id\n        }\n      }\n    }\n    parentGoal {\n      uuid\n      id\n    }\n  }\n  ...EditGoalProgressEditor\n}\n\nfragment GoalProgressEditor on Goal {\n  id\n  progress {\n    percentage\n    type\n  }\n  subGoals {\n    count\n  }\n  metricTargets {\n    edges {\n      node {\n        id\n        snapshotValue {\n          value\n          id\n        }\n        startValue\n        targetValue\n        metric {\n          id\n          name\n          type\n          subType\n          archived\n          source\n          latestValue {\n            time\n            id\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment GoalUpdateComposer_2WXTlx on Goal {\n  ...DueDateContext\n  ...NewGoalUpdate_2WXTlx\n  ...AddToMissedUpdateMessage\n  ari\n  latestUserUpdate {\n    id\n  }\n  id\n  uuid\n  workspace {\n    uuid\n    aiConfig {\n      enabled\n    }\n    id\n  }\n}\n\nfragment NewGoalUpdate_2WXTlx on Goal {\n  id\n  uuid\n  key\n  workspace {\n    uuid\n    id\n  }\n  phase {\n    name\n  }\n  state {\n    value\n    score\n  }\n  watchers {\n    count\n  }\n  latestUserUpdate {\n    id\n    editDate\n    creationDate\n    summary\n    notes {\n      title\n      summary\n      id\n    }\n  }\n  progress {\n    type\n  }\n  metricTargets {\n    edges {\n      node {\n        id\n      }\n    }\n  }\n  parentGoal {\n    uuid\n    id\n  }\n  ...hasMetric\n  ...GoalProgressEditor\n}\n\nfragment hasMetric on Goal {\n  progress {\n    type\n  }\n  metricTargets {\n    edges {\n      node {\n        metric {\n          archived\n          id\n        }\n        id\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "ad69c68f267ffefc5cd5aec62e492e64";

export default node;
